var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.className + ' form-group'},[_c('input',{staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.donationTotal,"readonly":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }